<child-header title="Update Finish" (closeEvent)="onNoClick()"></child-header>
<div mat-dialog-content>
  <div style="font-style: italic;" class="red-text mb-2">
    NCE subscriptions may take upto 4hrs to show in the portal
    <br>
    Suspend or Reactivate action may take upto 5 mins to show in the portal
  </div>
  <ng-container *ngFor="let finishSubscription of finishSubscriptions">
    <table class="table vertical-align" *ngIf="finishSubscription.isUpdateSuccessful">
      <thead>
        <tr class="color-green">
          <th colspan="2">
            <div style="white-space:normal;">
              The following subscription commitments have been updated in the Dicker
              Data Portal, until these changes have been successfully confirmed by Microsoft you will not be billed
              for new services and the subscriptions will show on our portal with a pending status.
            </div>
          </th>
        </tr>
        <tr>
          <th>SUBSCRIPTION DESCRIPTION</th>
          <th>STOCK DESCRIPTION</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td class='w200'>{{finishSubscription.subscriptionDescription}}</td>
          <td class='w200'>{{finishSubscription.stockDescription}}</td>
        </tr>
      </tbody>
    </table>
    <table id="subscriptionErrorTable" class="table" *ngIf="!finishSubscription.isUpdateSuccessful">
      <thead>
        <tr class="color-red">
          <th colspan="3">BELOW SUBSCRIPTION FAILED</th>
        </tr>
        <tr>
          <th>REFERENCE</th>
          <th>STOCK DESCRIPTION</th>
          <th>MESSAGE</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td class='w200'>{{finishSubscription.subscriptionDescription}}</td>
          <td class='w200'>{{finishSubscription.stockDescription}}</td>
          <td class='w200'>{{finishSubscription.message}}</td>
        </tr>
      </tbody>
    </table>
  </ng-container>

</div>
<div mat-dialog-actions>
  <button mat-button class="button button-red button-large" (click)="onNoClick()">OK</button>
</div>
